// React
import React from "react";
import { getRealDmsToken } from "../../active-directory/getDmsToken";

// Style
import "./Migration.css";

export default function Migration() {
  return (
    <div className="migration-container">
      <button
        className="migrate-button"
        id="button-migration-dms-token"
        onClick={async () => {
          const dmsToken = await getRealDmsToken();
          console.log("Bearer", dmsToken.accessToken);
        }}
      >
        Get Real DMS Token
      </button>
    </div>
  );
}
